import { useTeam } from "@/composables/team";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import { useTeamSubscription } from "@/composables/useTeamSubscription";

export const useTeamPermissions = () => {
  const page = usePage();
  const { isOnTeamPlan } = useTeamSubscription();
  const user = computed(() => page.props.user as any);
  const { team } = useTeam();

  const isOwner = computed(() => {
    if (!user.value || !team.value) {
      return false;
    }

    return team.value?.membership.role.key === "owner";
  });

  const hasRole = (role: string) => {
    if (!user.value || !team.value) {
      return false;
    }

    return team.value?.membership.role.key === role;
  };

  const hasPermission = (permission: string) => {
    if (!user.value || !team.value) {
      return false;
    }

    if (isOwner.value) return true;

    // 팀 구독이 'team' 이 아닌경우는 멤버들은 모두 false
    // 이게 가능한게 무료나, 프로의 경우 모두 1인 오너이기 때문에 권한이 필요없음
    if (!isOnTeamPlan.value) {
      return false;
    }

    const permissions = team.value?.membership?.role?.permissions ?? [];

    if (permissions?.length === 0) {
      return false;
    }

    // 정확한 권한 또는 전체 와일드카드 권한 체크
    if (permissions.includes(permission) || permissions.includes("*")) {
      return true;
    }

    const parts = permission.split(":");

    // 와일드카드를 포함한 모든 권한에 대해 체크
    for (const p of permissions) {
      const pParts = p.split(":");

      // 권한의 부분이 더 적거나 같은 경우에만 체크
      if (pParts.length <= parts.length) {
        let match = true;
        for (let i = 0; i < pParts.length; i++) {
          // 와일드카드가 아니고 부분이 일치하지 않으면 false
          if (pParts[i] !== "*" && pParts[i] !== parts[i]) {
            match = false;
            break;
          }
        }
        if (match) {
          return true;
        }
      }
    }

    return false;
  };

  return {
    isOwner,
    hasRole,
    hasPermission, // 권한 체크 로직
  };
};
